import React from 'react';

const Section = (props) => {
  const columnSize = props.columnSize ? props.columnSize : 12;
  const columnSizeClass = `is-${columnSize}`;
  const offsetCss = props.offsetCss
  return (
    <div className={`column ${offsetCss} ${columnSizeClass}`}>
      {props.title && (
        <h3 className="has-text-weight-semibold is-size-2">{props.title}</h3>
      )}
      {props.description && <p>{props.description}</p>}
      <div className="sectionContent">{props.children}</div>
    </div>
  );
};

export default Section;
